import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj418fmehvdt9fzl as NotBlankString__hashCode_impl_fxqzj4,
  NotBlankString2t6vf2scdbmna as NotBlankString,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SecretIdClass;
function SecretId() {
  if (SecretIdClass === VOID) {
    class $ {
      constructor(value) {
        this.p2f_1 = value;
      }
      toString() {
        return 'SecretId(value=' + NotBlankString__toString_impl_5tex9r(this.p2f_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.p2f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SecretId()))
          return false;
        if (!equals(new (NotBlankString())(this.p2f_1), new (NotBlankString())(other.p2f_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SecretId');
    SecretIdClass = $;
  }
  return SecretIdClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  SecretId as SecretId2b1ivn24svpd4,
};
//endregion

//# sourceMappingURL=SecretId.mjs.map
